export default (searchTerm, str) => {
    if (!str || typeof str !== 'string') return false;
    const value = str.toString().toLowerCase();
    const filterValue = searchTerm.toString().toLowerCase();
    return value.includes(filterValue);
};
